import { OptionPrice } from '../../lib/types/models/option-prices/option-price'
import { OptionPriceInput } from '../../lib/types/models/option-prices/option-price-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createOptionPrice(data: OptionPriceInput & { optionId: number }) {
  return restApiClient
    .url(constructApiUrl(API.optionPrices.create.url, null))
    .post<OptionPrice, OptionPriceInput & { optionId: number }>(data)
}
